import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { NicaAnagraficaComponent } from '../nica-anagrafica/nica-anagrafica.component';

@Component({
  selector: 'app-autisti',
  templateUrl: './autisti.component.html',
  styleUrls: ['./autisti.component.css']
})
export class AutistiComponent implements OnInit {
  @ViewChild('uAutisti', { static: true }) uAutisti: NicaAnagraficaComponent;  
  @Input() itemData:any
  filterSede:any;
  filterString
  constructor() { 
  
  }
  

  public inizializza(idSede:any):void{
   // alert(this.itemData[0]['idSede']);
    //this.uAutisti.filter="/"+this.itemData[0]['idSede'];
    if(idSede>0)
    this.filterSede = idSede
      this.uAutisti.filter="/"+idSede;
    
    this.uAutisti.refresh();
    
  }
  ngOnInit() {

    
    


    if(this.itemData)
   
        if(this.itemData[0]['idTabRif']>0)
        this.filterSede = this.itemData[0]['idTabRif'];
        this.filterString = '/' + this.itemData[0]['idTabRif'];


          
  }
  onAutistaSelected(e:any){

  }
  onAllEventAutisti(e:any){
    if(e.name==('onSaving')){
      
      e.changes[0]['data']['idSede']=this.filterSede
    }
  }
  SettaDati(){

  }
 
}
